import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import QuestionsContainer from '../../common/QuestionsContainer';
import AnswerAttribute from '../../common/AnswerAttribute';
import { getRequest, putRequest } from '../../../requestUtils';
import './WorkPreferences.scss';
import ProfileSuggestions from '../../ConsultantOnboarding/ProfileSuggestions';
import profileInterfaceAmico from '../../../../assets/images/profile-interface-amico.svg';
import { processedProfileSuggestions } from '../../ConsultantOnboarding/onboardingUtils';

const displayNumericRangeValue = (low, high, unit, symbol = '') => {
  if (low && low.toString().length > 0 && high && high.toString().length > 0) {
    return `${symbol}${low} - ${symbol}${high}${unit}`;
  }
  return `${symbol}${low || ''}${high || ''}${unit}`;
};

const renderField = (attribute, icon, answer) => (
  <div className={`work-preference ${attribute} body-text-2 mr-16`}>
    <i className={`fa ${icon} mr-5`} />
    {answer}
  </div>
);

class WorkPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      isHovering: false,
      showModal: props.showModal,
      showProfileSuggestionModal: false,
      answers: null,
      newResume: false,
      editErrorPresent: false,
    };
    this.getAnswers = this.getAnswers.bind(this);
    this.updateAnswers = this.updateAnswers.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleUpdateErrorState = this.handleUpdateErrorState.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseProfileSuggestionModal = this.handleCloseProfileSuggestionModal.bind(this);
    this.onSaveProfileSuggestion = this.onSaveProfileSuggestion.bind(this);
    this.onUpdateCompletionPercentage = this.onUpdateCompletionPercentage.bind(this);
    this.handleNewResume = this.handleNewResume.bind(this);
    this.renderPreferredHoursPerWeek = this.renderPreferredHoursPerWeek.bind(this);
  }

  componentDidMount() {
    this.updateAnswers();
  }

  onUpdateCompletionPercentage(answer) {
    const { updateCompletionPercentage } = this.props;
    const { newResume } = this.state;

    updateCompletionPercentage();

    if (answer.question_key === 'Resume' && newResume) {
      this.setState({ showProfileSuggestionModal: true });
    }
  }

  onSaveProfileSuggestion() {
    const { claimInfoUrl, csrfToken, hasChanged } = this.props;

    let data = processedProfileSuggestions(this.props);
    data = Object.keys(data)
      .filter((key) => hasChanged[_.camelCase(key)])
      .reduce((cur, key) => Object.assign(cur, { [key]: data[key] }), {});

    putRequest(
      claimInfoUrl,
      { claim_info: data },
      csrfToken,
    )
      .then(() => {
        window.location.reload();
      });
  }

  async getAnswers() {
    const {
      questionCategoryId, questionableId, questionableType, questionnaireName,
    } = this.props;
    const response = await getRequest('/question_answers/answers', {
      questionnaire_name: questionnaireName,
      question_category_id: questionCategoryId,
      questionable_id: questionableId,
      questionable_type: questionableType,
    });
    return response;
  }

  async updateAnswers() {
    const response = await this.getAnswers();
    this.setState({ answers: response.data });
  }

  handleNewResume(showSuggestions) {
    this.setState({ newResume: showSuggestions });
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    const { showModal } = this.state;
    if (!showModal) {
      this.setState({ isHovering: false });
    }
  }

  handleUpdateErrorState(error) {
    this.setState({ editErrorPresent: error });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    const { updateCompletionPercentage, updateAvailability, updateHourlyRate } = this.props;
    this.getAnswers().then((response) => {
      this.setState({ answers: response.data, showModal: false, isHovering: false });
      updateAvailability(response.data.find((a) => a.question_key === 'Is Available').answer);
      updateHourlyRate(response.data.find((a) => a.question_key === 'Hourly Rate Range').answer);
      updateCompletionPercentage();
    });
  }

  handleCloseProfileSuggestionModal() {
    this.setState({ showProfileSuggestionModal: false });
  }

  renderAdd(attribute, text) {
    return (
      <div className="work-preference">
        <a
          className={`add-answer ${attribute} body-text-3 mr-16`}
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          <i className="fa fa-plus" />
          {`Add ${text}`}
        </a>
      </div>
    );
  }

  renderAttribute(attribute, icon, answer, addText) {
    const {
      fullView,
    } = this.props;
    if (answer) {
      return renderField(attribute, icon, answer);
    }
    if (fullView) {
      return this.renderAdd(attribute, addText);
    } return null;
  }

  renderHourlyRateRange(hourlyRate) {
    const {
      fullView,
    } = this.props;
    if (hourlyRate && (!hourlyRate.answer || (!hourlyRate.answer.low && !hourlyRate.answer.high))) {
      if (fullView) {
        return (
          <div className="work-preference body-text-3">
            {this.renderAdd('hourly rate', 'Hourly Rate')}
          </div>
        );
      } return null;
    }
    return (
      <div className="work-preference">
        <i className="fas fa-dollar-sign" />
        {displayNumericRangeValue(Math.round(hourlyRate.answer.low), Math.round(hourlyRate.answer.high), '/hr', '$')}
      </div>
    );
  }

  renderPreferredHoursPerWeek(availability) {
    if (availability
      && (!availability.answer || !availability.answer.id)) {
      return (
        <div className="work-preference availability body-text-3">
          {this.renderAdd('hours_per_week', 'Hours Per Week')}
        </div>
      );
    }
    return (
      <div className="work-preference availability">
        <i className="fas fa-clock" />
        Preferred hours per week:
        {' '}
        {availability.answer.value}
      </div>
    );
  }

  renderAvailability(answers) {
    const isAvailable = answers.find((a) => a.question_key === 'Is Available');
    const availability = answers.find((a) => a.question_key === 'Availability');

    if (isAvailable.answer.value === 'yes') {
      return (
        <Fragment>
          {this.renderPreferredHoursPerWeek(availability)}
        </Fragment>
      );
    } if (isAvailable.answer.value === 'no') {
      return (
        <div className="work-preference g-row--always">
          <div><i className="fas fa-calendar" /></div>
          <div>Not available</div>
        </div>
      );
    }

    return (
      <div className="work-preference availability body-text-3">
        {this.renderAdd('availability', 'Availability')}
      </div>
    );
  }

  renderForm() {
    const {
      questionnaireQuestions,
      questionableId,
      questionableType,
      questionnaireName,
      csrfToken,
    } = this.props;
    return (
      <div className="work-preferences-form">
        <QuestionsContainer
          questionnaireName={questionnaireName}
          questionIds={questionnaireQuestions}
          questionableId={questionableId}
          questionableType={questionableType}
          csrfToken={csrfToken}
          handleToggleSave={this.handleUpdateErrorState}
          owner
        />
      </div>
    );
  }

  renderEdit() {
    const { editMode } = this.props;
    const { isHovering } = this.state;

    if (isHovering || editMode) {
      return (
        <a
          className="edit-work-preference medium-weight"
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          Edit
        </a>
      );
    }
    return null;
  }

  renderEditWorkPreference() {
    const { editMode } = this.props;
    const { isHovering } = this.state;

    if (isHovering || editMode) {
      return (
        <a
          className="edit-work-preference"
          tabIndex={0}
          role="button"
          onClick={() => this.handleShowModal()}
        >
          Edit
        </a>
      );
    }
    return null;
  }

  renderProfileSuggestions() {
    const {
      questionableId,
      questionableType,
      questionnaireName,
      userId,
    } = this.props;

    return (
      <div className="profile-suggestions-wrapper">
        <div className="header">
          <div className="content">
            <h1 className="title">We found some profile suggestions for you!</h1>
            <p className="description">
              Any existing information in the fields you select below will be overwritten.
              Uncheck any items you want to leave out.
            </p>
          </div>
          <div>
            <img
              src={profileInterfaceAmico}
              alt="profile interface amico"
              className="brand-img"
              height={139}
              width={142}
            />
          </div>
        </div>
        <div className="profile-suggestions">
          <ProfileSuggestions
            questionnaireName={questionnaireName}
            questionableId={questionableId}
            questionableType={questionableType}
            userId={userId}
            fromOnboarding={false}
          />
        </div>
        <div className="footer">
          <Button variant="secondary" onClick={this.handleCloseProfileSuggestionModal}>
            Skip
          </Button>
          <Button variant="primary" onClick={this.onSaveProfileSuggestion}>
            Update My Profile
          </Button>
        </div>
      </div>
    );
  }

  renderAnswerAttribute(answer, customClass, updateCallback) {
    const {
      questionCategoryId,
      questionnaireId,
      questionableId,
      questionableType,
      questionnaireName,
      csrfToken,
      fullView,
      editMode,
      userId,
    } = this.props;

    return (
      <AnswerAttribute
        customClass={customClass}
        answer={answer}
        questionCategoryId={questionCategoryId}
        questionableId={questionableId}
        questionableType={questionableType}
        csrfToken={csrfToken}
        questionnaireId={questionnaireId}
        questionnaireName={questionnaireName}
        fullView={fullView}
        editMode={editMode}
        updateCompletionPercentage={updateCallback}
        updateAnswers={this.updateAnswers}
        userId={userId}
        handleNewResume={this.handleNewResume}
      />
    );
  }

  renderModals() {
    const { showModal, showProfileSuggestionModal, editErrorPresent } = this.state;

    return (
      <Fragment>
        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton className="no-border-bottom" />
          <Modal.Body className="style-guide">{this.renderForm()}</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" disabled={editErrorPresent} onClick={this.handleCloseModal}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal size="lg" dialogClassName="profile-suggestions-modal" show={showProfileSuggestionModal} onHide={this.handleCloseProfileSuggestionModal}>
          <Modal.Header closeButton className="no-border-bottom" />
          <Modal.Body className="style-guide">{this.renderProfileSuggestions()}</Modal.Body>
          <Modal.Footer />
        </Modal>
      </Fragment>
    );
  }

  renderWorkPreferences() {
    const { answers } = this.state;
    const { fullView } = this.props;
    const hourlyRate = answers.find((a) => a.question_key === 'Hourly Rate Range');
    const roleType = answers.find((a) => a.question_key === 'Role Type');

    if (!fullView && (!hourlyRate
        || (!hourlyRate.answer || (!hourlyRate.answer.low && !hourlyRate.answer.high)))
          && (!roleType || roleType.answer.length === 0)) {
      return null;
    }

    return (
      <div className="profile-section work-preferences body-text-2">
        <div
          onMouseOver={this.handleMouseOver}
          onFocus={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
        >
          <h2 className="mb-4">
            Work Preferences
            <span className="body-text-2">{this.renderEditWorkPreference()}</span>
          </h2>
          {this.renderHourlyRateRange(hourlyRate)}
          {this.renderAttribute('employment-preference', 'fa-atom', roleType && roleType.answer.map((a) => a.label).join(' & '), 'Work Preference')}
          {answers.find((a) => a.question_key === 'Is Available') && fullView && this.renderAvailability(answers)}
        </div>
      </div>
    );
  }

  render() {
    const { answers } = this.state;
    const { fullView } = this.props;
    if (!answers) {
      return (
        <div className="profile-section work-preferences body-text-2">Work Preferences</div>
      );
    }

    const resume = answers.find((a) => a.question_key === 'Resume');
    const linkedin = answers.find((a) => a.question_key === 'Linkedin');

    return (
      <div>
        {fullView && (
          <div className="profile-section preferences body-text-2">
            {resume && this.renderAnswerAttribute(resume, 'mb-4', () => this.onUpdateCompletionPercentage(resume))}
            {linkedin && this.renderAnswerAttribute(linkedin, 'mb-4', this.props.updateCompletionPercentage)}
          </div>
        )}
        {this.renderWorkPreferences()}
        {this.renderModals()}
      </div>
    );
  }
}

WorkPreferences.propTypes = {
  questionCategoryId: PropTypes.number.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.arrayOf(PropTypes.number).isRequired,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func.isRequired,
  updateAvailability: PropTypes.func.isRequired,
  updateHourlyRate: PropTypes.func.isRequired,
  questionnaireId: PropTypes.number.isRequired,
  fullView: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  hasChanged: PropTypes.shape({}).isRequired,
  showModal: PropTypes.bool,
};

WorkPreferences.defaultProps = {
  fullView: true,
  editMode: false,
  showModal: false,
};

const mapStateToProps = (state) => {
  const { profileSuggestions, hasChanged } = state.profileSuggestions;

  return {
    ...profileSuggestions.merged,
    hasChanged,
  };
};

export default connect(mapStateToProps)(WorkPreferences);
